import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F3F4F6] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="bg-white border border-[#E5E7EB] rounded-xl p-8 shadow-sm">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-full bg-[#FAFAF7] p-1 ring-2 ring-[#FACC15]/40 overflow-hidden">
              <img src="/ssu-logo.jpg" alt="SSU Workshops" className="w-full h-full object-contain" />
            </div>
            <div className="leading-tight">
              <div className="font-display text-lg text-[#0A1128]">SSU <span className="text-[#A16207]">WORKSHOPS</span></div>
              <div className="text-[10px] text-[#6B7280] uppercase tracking-[0.25em] mt-0.5">Admin Console</div>
            </div>
          </div>

          <h1 className="font-display-tight text-2xl text-[#0A1128] mb-1">Sign in</h1>
          <p className="text-sm text-[#6B7280] mb-6">Private dashboard. Authorized administrators only.</p>

          <form onSubmit={submit} data-testid="admin-login-form" className="space-y-4">
            <div>
              <Label className="text-sm font-semibold text-[#0A1128]">Email</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 h-11 border-[#E5E7EB] focus-visible:ring-[#0066FF] focus-visible:ring-2"
                data-testid="admin-email-input"
                required
              />
            </div>
            <div>
              <Label className="text-sm font-semibold text-[#0A1128]">Password</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 h-11 border-[#E5E7EB] focus-visible:ring-[#0066FF] focus-visible:ring-2"
                data-testid="admin-password-input"
                required
              />
            </div>
            <button
              type="submit"
              disabled={submitting}
              data-testid="admin-login-submit"
              className="w-full bg-[#0066FF] hover:bg-[#0052CC] disabled:opacity-60 text-white font-bold uppercase tracking-wider text-sm py-3 rounded-md transition-colors"
            >
              {submitting ? "Signing in…" : "Log In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
